<template>
  <div
    class="DesignProposalForm MSWForm"
    style="background-color: rgb(255, 255, 255)"
  >
    <div class="internal-container mx-auto">
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            
                <!-- <div class="text-center mx-auto">
                  <span class="bold product-title pr-2">Design</span>
                  <span class="product-title">Proposal</span>
                </div> -->
  
                <v-form ref="form" v-model="valid" lazy-validation>

                  <v-row v-if="false">
                    <v-col cols="12">
                      <span class="label">
                        Project Name:
                      </span>
                      <v-text-field
                        v-model="project"
                        outlined
                        hide-details
                        color="gray"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <span class="label">
                        SKU:
                      </span>
                      <v-text-field
                        v-model="SKU"
                        outlined
                        hide-details
                        color="gray"
                      ></v-text-field>
                    </v-col>
                  </v-row>
  
                  <v-row v-if="false">
                    <v-col cols="12">
                      <span class="label">
                        Name:
                      </span>
                      <v-text-field
                        v-model="Name"
                        outlined
                        hide-details
                        color="gray"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <span class="label">
                        Type:
                      </span>
                      <v-text-field
                        v-model="Type"
                        outlined
                        hide-details
                        color="gray"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <span class="label">
                        Email Address:
                      </span>
                      <v-text-field
                        v-model="email"
                        outlined
                        hide-details
                        color="gray"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <span class="label">
                        Project/Client:
                      </span>
                      <v-text-field
                        v-model="project"
                        outlined
                        hide-details
                        color="gray"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <span class="label">
                        Name/Company:
                      </span>
                      <v-text-field
                        v-model="Name"
                        outlined
                        hide-details
                        color="gray"
                      ></v-text-field>
                    </v-col>
                  </v-row>
  
                  <v-row>
                    <v-col cols="12">
                      <span class="d-block">
                        <span class="label">
                          General Dimensions
                        </span>
                      </span>
                      <span class="d-block label-small my-2">W x D x H / Seat H:</span>
                      <v-textarea
                        v-model="GeneralDimensions"
                        outlined
                        hide-details
                        color="gray"
                        auto-grow
                        rows="1"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12">
                      <span class="label">
                        Materials / Finishes:
                      </span>
                      <v-textarea
                        v-model="Materials"
                        outlined
                        hide-details
                        color="gray"
                        auto-grow
                        rows="1"
                      ></v-textarea>
                    </v-col>
                  </v-row>
  
                  <v-row>
                    <v-col cols="12" v-if="false">
                      <span class="label">
                        Finishes: 
                      </span>
                      <v-textarea
                        v-model="Finishes"
                        outlined
                        hide-details
                        color="gray"
                        auto-grow
                        rows="1"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12">
                      <span class="label">
                        Hardware Specifications:
                      </span>
                      <v-textarea
                        v-model="HardwareSpecifications"
                        outlined
                        hide-details
                        color="gray"
                        auto-grow
                        rows="1"
                      ></v-textarea>
                    </v-col>
                  </v-row>
  
                  <v-row>
                    <v-col cols="12">
                      <span class="label">
                        Notes / Details:
                      </span>
                      <v-textarea
                        v-model="Notes"
                        outlined
                        hide-details
                        color="gray"
                        auto-grow
                        rows="1"
                      ></v-textarea>
                    </v-col>
                  </v-row>
  
                  <v-row>
                    <v-col>
                      <label class="label">
                        Upload Reference Images
                      </label>
                      <v-file-input
                        v-model="files"
                        outlined
                        class="mx-auto"
                        multiple
                        chips
                        color="black"
                        :prepend-icon="false"
                        prepend-inner-icon="mdi-paperclip"
                      ></v-file-input>
                    </v-col>
                  </v-row>
  
                </v-form>
  
                <button 
                  @click="validate"
                  class="MSWButton"
                >
                  Submit
                </button>

                <span class="ml-12 label d-inline-block" v-if="showThankyou">Thank you!</span>
                <!-- <v-btn
                  color="rgb(168,166,161)"
                  tile
                  class="mr-4"
                  @click="validate"
                  :ripple="false"
                  elevation="0"
                  outlined
                  height="80"
                  width="150"
                >
                  <span class="bold ml-1">Submit</span>
                </v-btn> -->
              
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
export default {
  data() {
    return {
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      required: [(v) => !!v || "Required"],
      email: '',
      project: '',
      SKU: '',
      Name: '',
      Type: '',
      GeneralDimensions: '',
      Materials: '',
      Finishes: '',
      HardwareSpecifications: '',
      Notes: '',
      files: [],
      showThankyou: false
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    radioGroup: function () {
      this.otherCard = '';
    }
  },
  mounted: function () {
    this.$emit("update", 6);
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
    },
    validate() {
      if (this.$refs.form.validate()) {
        var aux = this;

        // let data = {
        //   Email: aux.email,
        //   Project: aux.project,
        //   Name: aux.name,
        //   InvoiceReference: aux.invoiceRefereence,
        //   CardName: aux.cardName,
        //   CreditCardType: aux.radioGroup,
        //   OtherCard: aux.otherCard,
        //   CardNumber: aux.cardNumber,
        //   SecurityCode: aux.securityCode,
        //   ExpirationDate: aux.expirationDate,
        //   Street: aux.streetAdress,
        //   City: aux.city,
        //   State: aux.state,
        //   ZipCode: aux.zipCode,
        //   Date: aux.date,
        // };

        // fetch(
        //   "https://www.artlesscms.actstudio.xyz/api/forms/submit/ChargeCardAuthorizationForm?token=cf00a9204acb3ab54e671ca7655e5f",
        //   {
        //     method: "post",
        //     headers: { "Content-Type": "application/json" },
        //     body: JSON.stringify({
        //       form: data,
        //     }),
        //   }
        // )
        //   .then((entry) => entry.json())
        //   .then((entry) => console.log(entry))
        //   .then(this.copiaCollection(data))
        //   .then(this.reiniciar());

        let datos = new FormData();

        for (let index = 0; index < this.files.length; index++) {
            datos.append("files[" + index + "]", this.files[index]);
        }

        let config = {
              header: {
                "Content-Type": "multipart/form-data"
              }
          };

          if(this.files.length > 0){

            axios.post(
              "https://www.artlesscms.actstudio.xyz/api/cockpit/addAssets?token=cf00a9204acb3ab54e671ca7655e5f",
              datos,
              config
            )
            .then(function (res) {
              var routes = [];
  
              for (let index = 0; index < res.data.assets.length; index++) {
                  const element = res.data.assets[index].path;
                  routes.push(element);
              }
  
              let data = {
                  'Email': aux.email,
                  'Project/Client:': aux.project,
                  'Name/Company': aux.Name,
                  'Type': aux.Type,
                  'GeneralDimensions': aux.GeneralDimensions,
                  'Materials': aux.Materials,
                  'HardwareSpecifications': aux.HardwareSpecifications,
                  'Notes': aux.Notes,
                  'File': "https://www.artlesscms.actstudio.xyz/storage/uploads" + routes[0]
              }
  
              fetch('https://www.artlesscms.actstudio.xyz/api/forms/submit/MSWDesignProposal?token=cf00a9204acb3ab54e671ca7655e5f', {
                  method: 'post',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                      form: data
                  })
              })
              .then(entry => entry.json())
              .then(aux.reiniciar());
            });
          }else{
            let data = {
                  'Email': aux.email,
                  'Project/Client:': aux.project,
                  'Name/Company': aux.Name,
                  'Type': aux.Type,
                  'GeneralDimensions': aux.GeneralDimensions,
                  'Materials': aux.Materials,
                  'HardwareSpecifications': aux.HardwareSpecifications,
                  'Notes': aux.Notes,
              }
  
              fetch('https://www.artlesscms.actstudio.xyz/api/forms/submit/MSWDesignProposal?token=cf00a9204acb3ab54e671ca7655e5f', {
                  method: 'post',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                      form: data
                  })
              })
              .then(entry => entry.json())
              .then(aux.reiniciar());
          }
      }
    },
    copiaCollection: function (formData){
      fetch('https://www.artlesscms.actstudio.xyz/api/collections/save/ChargeCardAuthorizationForm', {
          method: 'post',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
              data: formData
          })
      })
      .then(res=>res.json());
    },
    reiniciar: function () {
      this.showThankyou = true;
      this.$refs.form.reset()
      setTimeout(() => {
        this.showThankyou = false;
      }, 5000);
      // this.$emit("openSnackbar");
    },
  },
};
</script>